import { Badge } from "@/components/ui/badge";

interface LabelInfo {
  id?: string;
  label?: string;
  color?: string | null;
}

interface EntityLabelsProps {
  labels?: LabelInfo[] | null;
  /** Size variant: "sm" for tight spaces (list items), "default" for normal */
  size?: "sm" | "default";
  /** Maximum labels to show before "+N more" */
  maxVisible?: number;
  className?: string;
}

export function EntityLabels({
  labels,
  size = "default",
  maxVisible,
  className,
}: EntityLabelsProps) {
  if (!labels || labels.length === 0) return null;

  const visibleLabels = maxVisible ? labels.slice(0, maxVisible) : labels;
  const remaining = maxVisible ? labels.length - maxVisible : 0;

  return (
    <div className={`inline-flex flex-wrap gap-1 ${className || ""}`}>
      {visibleLabels.map((label) => (
        <Badge
          key={label.id}
          variant="secondary"
          className={
            size === "sm" ? "text-xs px-1.5 py-0 leading-4" : ""
          }
          style={{
            backgroundColor: label.color ? `${label.color}20` : undefined,
            borderColor: label.color || undefined,
            color: label.color || undefined,
          }}
        >
          {label.label}
        </Badge>
      ))}
      {remaining > 0 && (
        <Badge
          variant="outline"
          className={
            size === "sm" ? "text-xs px-1.5 py-0 leading-4" : ""
          }
        >
          +{remaining}
        </Badge>
      )}
    </div>
  );
}
